import { Badge, Button, FormControl, FormLabel, HStack, Link, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { fetchCompany, updateUIColorScheme } from '../../../../../store/actions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';

import { AppDispatch } from '../../../../../store';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { FiCheck } from 'react-icons/fi';

export const ColorSchemeSection = () => {

    const [selectedScheme, setSelectedScheme] = useState<string>('');
    const [isUpdatingColorScheme, setIsUpdatingColorScheme] = useState<boolean>(false);

    const { company } = useAppSelector(state => state.companyReducer);

    const { company_id, website } = company;

    const colorSchemes = [
        {
            name: 'gray',
            color: '#718096'
        },
        {
            name: 'red',
            color: '#E53E3E'
        },
        {
            name: 'orange',
            color: '#ED8936'
        },
        {
            name: 'yellow',
            color: '#D69E2E'
        },
        {
            name: 'green',
            color: '#38A169'
        },
        {
            name: 'teal',
            color: '#319795'
        },
        {
            name: 'blue',
            color: '#3182CE'
        },
        {
            name: 'cyan',
            color: '#00B5D8'
        },
        {
            name: 'purple',
            color: '#6B46C1'
        },
        {
            name: 'pink',
            color: '#D53F8C'
        },
    ];

    const dispatch: AppDispatch = useAppDispatch();

    const handleColorSchemeUpdate = () => {
        setIsUpdatingColorScheme(true);
        const [scheme] = colorSchemes?.filter((scheme: any) => scheme?.name === selectedScheme);
        const values = { company_id, color: scheme?.color, color_scheme: scheme?.name };
        dispatch(updateUIColorScheme(values))
            .then(() => { setIsUpdatingColorScheme(false); dispatch(fetchCompany()); })
            .catch(() => setIsUpdatingColorScheme(false));
    };

    useEffect(() => {
        setSelectedScheme(website?.color_scheme ?? '');
    }, []);

    return (
        <>
            <form>
                <FormControl isRequired mb={3}>
                    <FormLabel>Color scheme</FormLabel>
                    <HStack justifyContent={'space-between'} mb={3}>
                        <Text color={'gray.500'}>Selected color scheme: <Badge colorScheme={selectedScheme}>{selectedScheme || '-'}</Badge> 😊 </Text>
                        <Link href={'https://chakra-ui.com' || <></>} color={'blue.500'} isExternal>
                            Preview <ExternalLinkIcon mx='2px' />
                        </Link>
                    </HStack>
                    <SimpleGrid columns={[2, 3, 4, 5]} spacing={4}>
                        {
                            colorSchemes?.map((scheme: any, index: number) => (
                                <HStack key={index} boxShadow={'md'} p={2} borderRadius={'md'} justifyContent={'space-between'} cursor={'pointer'}
                                    borderWidth={scheme?.name === selectedScheme ? 2 : 0}
                                    borderColor={scheme?.name === selectedScheme ? 'green.500' : 'white'}
                                    _hover={{
                                        boxShadow: 'lg'
                                    }}
                                    onClick={() => setSelectedScheme(scheme?.name)}
                                >
                                    <Stack w={'30px'} h={'30px'} bg={scheme?.color} borderRadius={'md'}></Stack>
                                    <Text textTransform={'capitalize'} fontWeight={'medium'}>{scheme?.name}</Text>
                                    <Stack p={1} borderRadius={'full'} borderWidth={1} bg={scheme?.name === selectedScheme ? 'green.500' : 'white'} borderColor={scheme?.name === selectedScheme ? 'green.500' : 'gray.500'}>
                                        <FiCheck color={scheme?.name === selectedScheme ? 'white' : 'gray'} />
                                    </Stack>
                                </HStack>
                            ))
                        }
                    </SimpleGrid>
                </FormControl>
                <Button my={3} float={'right'}
                    colorScheme={'yellow'}
                    onClick={() => handleColorSchemeUpdate()}
                    disabled={isUpdatingColorScheme}
                    isLoading={isUpdatingColorScheme}
                    loadingText={'Updating...'}
                >Update</Button>
            </form>
        </>
    );

};